import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface EligibleItem {
  fn110_01: string;    // 客訴單號
  fn110_11: string;    // 日期
  fn110_812: string;   // 品保核准狀態
  fn110_17: number;    // 客訴金額
  fn110_8121: string;  // 品保意見
  fn110_22: string;    // 部門
}

export interface SearchResponse {
  items: EligibleItem[];
  total: number;
}

export interface ExecuteResultItem {
  doc_no: string;
  success: boolean;
  message: string;
}

export interface ExecuteResponse {
  results: ExecuteResultItem[];
  success: number;
  failed: number;
  message: string;
}

export interface SearchFilter {
  startNo: string;
  endNo: string;
}

// ============================================================
// API methods
// ============================================================

export const n5m3Api = {
  // POST /api/n5m3/search
  async search(filter: SearchFilter): Promise<SearchResponse> {
    const res = await apiClient.post('/api/n5m3/search', {
      start_no: filter.startNo,
      end_no: filter.endNo,
    });
    return res.data;
  },

  // POST /api/n5m3/execute
  // confirmed:true mirrors the Popconfirm the user already went through in
  // N5M3Form (FoxPro's PWU016F2 "請確認沖銷本資料!" dialog) — the backend
  // now requires it (BR-V05).
  async execute(docNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/n5m3/execute', { doc_nos: docNos, confirmed: true });
    return res.data;
  },
};
